/**
 * Animations Module
 * GSAP animations and polaroid slider animations
 */

import { gsap } from "gsap";
// import { Splide } from "@splidejs/splide";

export function initAnimations() {
  // GSAP animations for Momen Polaroids - synced with testimonial slider
  // initMomenPolaroidAnimations();
}

// function initMomenPolaroidAnimations() {
//   // Sync polaroid slider with testimonial slider
//   const polaroidSlider = document.querySelector('.splideMomenPolaroid');
//   const testimonialSlider = document.querySelector('.splideMomenTestimonial');

//   if (!polaroidSlider || !testimonialSlider) return;

//   // Initialize polaroid slider (no arrows, no pagination, sync with testimonial)
//   const splidePolaroid = new Splide(polaroidSlider, {
//     type: 'loop',
//     perPage: 1,
//     arrows: false,
//     pagination: false,
//     drag: false,
//     speed: 600,
//     easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
//   });

//   // Initialize testimonial slider with custom arrows
//   const splideTestimonial = new Splide(testimonialSlider, {
//     type: 'loop',
//     perPage: 1,
//     arrows: true,
//     pagination: false,
//     speed: 600,
//     easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
//   });

//   // Sync the sliders
//   splideTestimonial.on('move', (newIndex, prevIndex, destIndex) => {
//     splidePolaroid.go(destIndex);
//   });

//   splidePolaroid.mount();
//   splideTestimonial.mount();

//   // Add entrance animation for polaroid stacks
//   const polaroidStacks = document.querySelectorAll('.polaroid-stack');

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach((entry) => {
//       if (entry.isIntersecting) {
//         const stack = entry.target;
//         const mainPolaroid = stack.querySelector('.polaroid-main');
//         const backPolaroids = stack.querySelectorAll('.polaroid-back');

//         // Animate main polaroid
//         gsap.fromTo(mainPolaroid,
//           { opacity: 0, scale: 0.7, y: 50 },
//           { opacity: 1, scale: 1, y: 0, duration: 0.6, ease: 'back.out(1.4)' }
//         );

//         // Animate back polaroids with stagger
//         gsap.fromTo(backPolaroids,
//           { opacity: 0, scale: 0.6 },
//           { opacity: 1, scale: 1, duration: 0.5, stagger: 0.1, ease: 'back.out(1.2)', delay: 0.2 }
//         );

//         observer.unobserve(stack);
//       }
//     });
//   }, { threshold: 0.3 });

//   polaroidStacks.forEach(stack => observer.observe(stack));
// }

export function animateHeroContent(heroContent) {
  if (heroContent) {
    gsap.fromTo(heroContent,
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: "power2.out" }
    );
  }
}

export function animateThumbnail(thumbnailContainer) {
  if (thumbnailContainer) {
    gsap.fromTo(thumbnailContainer,
      { x: 100, opacity: 0 },
      { x: 0, opacity: 1, duration: 0.8, ease: "power2.out", delay: 0.3 }
    );
  }
}

export function fadeInModal(modalContainer, modalContent) {
  gsap.fromTo(
    modalContainer,
    { opacity: 0 },
    { opacity: 1, duration: 0.3, ease: "power2.out" }
  );

  gsap.fromTo(
    modalContent,
    { scale: 0.8, y: 50 },
    { scale: 1, y: 0, duration: 0.3, ease: "power2.out" }
  );
}

export function fadeOutModal(modalContainer, onComplete) {
  gsap.to(modalContainer, {
    opacity: 0,
    duration: 0.2,
    ease: "power2.in",
    onComplete
  });
}

/**
 * Initialize bar marquee animation with GSAP
 * Creates infinite scrolling marquee moving left
 * Animation: 8000ms linear with 1ms delay
 */
export function initBarMarquee() {
  const marquees = document.querySelectorAll('.bar-marquee');

  marquees.forEach((marquee) => {
    const track = marquee.querySelector('.marquee-track');
    if (!track) return;

    // Get all original items
    const items = track.querySelectorAll('.item');
    if (items.length === 0) return;

    // Clone items enough times to fill the viewport width for seamless loop
    const marqueeWidth = marquee.offsetWidth;
    let trackWidth = track.scrollWidth;
    const minClones = Math.ceil((marqueeWidth * 3) / trackWidth) + 1;

    for (let i = 0; i < minClones; i++) {
      items.forEach((item) => {
        const clone = item.cloneNode(true);
        track.appendChild(clone);
      });
    }

    // Recalculate track width after cloning
    trackWidth = track.scrollWidth / (minClones + 1);

    // Set initial position
    gsap.set(track, { x: 0 });

    // Create infinite marquee animation moving left
    // Animate only one set of items width for seamless loop
    const marqueeAnimation = gsap.to(track, {
      x: -trackWidth,
      duration: 50, // 20 seconds for slower, smoother animation
      ease: "none",
      repeat: -1,
      delay: 0.001, // 1ms delay as per Figma spec
    });

    // Pause animation when tab is hidden for performance
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        marqueeAnimation.pause();
      } else {
        marqueeAnimation.resume();
      }
    });
  });
}
